/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncKbNav } from '@jira/navigation-apps__horizontal-nav-jsm-knowledge-base/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { knowledgeHubLandingRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/knowledgeHubLandingRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { projectIdResource } from '@jira/router-resources__knowledge-hub/src/projectIdResource.tsx';
import { kbTopicsResource } from '@jira/router-resources__knowledge-hub/src/kbTopicsResource.tsx';
import { knowledgeHubBrowseAllArticlesKBTypeCheckerResource } from '@jira/router-resources__knowledge-hub/src/knowledgeHubBrowseAllArticlesKBTypeCheckerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubLandingPage, {
	LazyServicedeskKnowledgeHubLanding,
} from './ui/landing-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const knowledgeHubLandingRouteEntry: Route = createEntry(knowledgeHubLandingRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ServiceDeskKnowledgeHubLandingPage,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncKbNav,
		// TODO: Remove this during jira_nav4 cleanup
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getKnowledgeHubResources(),
		getConsolidationStateResource(),
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), projectIdResource),
		resourceWithCondition(() => fg('jsm-kb-articles-functional'), kbTopicsResource),
		resourceWithCondition(
			() => fg('jsm-kb-articles-functional'),
			knowledgeHubBrowseAllArticlesKBTypeCheckerResource,
		),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubLanding],

	meta: {
		reporting: {
			id: APP_NAMES.KB_LANDING,
			packageName: toPackageName(APP_NAMES.KB_LANDING),
			teamName: 'jsm-nebula',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
